import {
  SIDEBAR_OPEN,
  SIDEBAR_CLOSE,
  TOGGLE_TRAILHEADS_TRIPS,
} from '../common/actionTypes';

const defaultState = {
  open: true,
  trailheads: true,
};

export default (state = defaultState, action) => {
  switch(action.type) {
    case SIDEBAR_OPEN:
      return {
        ...state,
        open: true,
      };

    case SIDEBAR_CLOSE:
      return {
        ...state,
        open: false,
      };

    case TOGGLE_TRAILHEADS_TRIPS:
      return {
        ...state,
        trailheads: !state.trailheads,
      };

    default:
      return state;
  };
};



// WEBPACK FOOTER //
// ./map/reducers/sidebarReducer.js